import { createInfo } from '@liveauctioneers/hammer-ui-core/card/components/createInfo';
import { MapPin } from '@liveauctioneers/hammer-ui-core/icons';
import { BodySecondary } from '@liveauctioneers/hammer-ui-core/text';

import { useAppSelector } from '@/redux/hooks';
import {
    getItemSummaryLotLocationDisplay,
    getItemSummarySellerName,
} from '@/redux/modules/item/summary/itemSummary.selectors';
import { ItemSummary } from '@/types/item/ItemSummary';

export type SellerNameComponentSearchCardProps = ItemSummary & { position: number };

export const SellerNameComponentSearchCard = createInfo<SellerNameComponentSearchCardProps>({
    className: 'line-clamp-0',
    useText: ({ itemId }) => {
        const sellerName = useAppSelector((state) => getItemSummarySellerName(state, itemId));
        const {
            city: lotLocationCity,
            countryCode: lotLocationCountryCode,
            region: lotLocationRegion,
        } = useAppSelector((state) => getItemSummaryLotLocationDisplay(state, itemId));

        const sellerLocation =
            lotLocationCity === lotLocationRegion
                ? [lotLocationCity, lotLocationCountryCode].filter(Boolean).join(', ')
                : [lotLocationCity, lotLocationRegion].filter(Boolean).join(', ');

        return (
            <div className="mb-xs mt-auto flex min-w-0 flex-col gap-y-2xs px-xs smMin:flex-row smMin:items-baseline smMin:gap-x-xs smMin:px-sm">
                <BodySecondary className="order-2 block w-full min-w-0 truncate text-xs text-text-secondary smMin:order-1 smMin:w-auto smMin:flex-1 smMin:text-sm">
                    {sellerName}
                </BodySecondary>
                {sellerLocation && (
                    <BodySecondary className="order-1 flex min-w-0 translate-x-[-2px] items-baseline gap-x-2xs text-xs text-text-secondary smMin:order-2 smMin:shrink-0 smMin:translate-x-0 smMin:text-sm">
                        <span className="inline-flex shrink-0 translate-y-[2px] leading-none">
                            <MapPin size="xs" />
                        </span>
                        <span className="min-w-0 smMin:truncate">{sellerLocation}</span>
                    </BodySecondary>
                )}
            </div>
        );
    },
});
